var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoAdvisorAssigned = function SvgNoAdvisorAssigned(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 66,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.682,
    cy: 32.932,
    r: 32.317,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.493,
    cy: 32.743,
    r: 31.14,
    fill: "#FAFAFA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.237,
    cy: 24.192,
    r: 9.746,
    fill: "#FF2E5B",
    transform: "rotate(180 32.237 24.192)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5B3552",
    d: "M49.291 50.994c0-9.419-7.636-17.055-17.055-17.055s-17.055 7.636-17.055 17.055z"
  })));
};
export { SvgNoAdvisorAssigned as ReactComponent };
export default __webpack_public_path__ + "images/no-advisor-assigned.svg";